// extracted by mini-css-extract-plugin
export default {"wrapper":"login_wrapper__Tm9nu","loginBtn":"login_loginBtn__URMrM"};